// 文章103数据信息
export default {
  id: '103',
  title: '合作专家介绍',
  createTime: '2025-04-21 11:00:00',
  content: `## 王微

![img](https://cdn.keihong.tech/img/20250421202925590.png)

擅长中老年慢性病干预的运动疗法和营养疗法

北京体育大学硕士

中国老年医学会与运动健康分会青年骨干

中国心脏联盟心血管疾病预防与康复专业委员会运动康复专业认证

美国国家运动医学会(NASM)国际年长者健康体适能专业认证

美国体适能协会(AFAA)国际年长者团体运动指导师专业认证

中国健美协会专业健身教练认证

国家注册社会体育指导员认证

人社部青少年体适能职业认证

CNC营养管理师（健身方向）专业认证

中国营养学会会员

全国老年大学、养老机构、康养社区特邀专家

年长者体适能健康教育体系创始人

## 宁绍超

![img](https://cdn.keihong.tech/img/20250421202925523.png)

西安体育学院本科毕业

国家二级散打运动员

14年健身教练及康复教学经验

广东省老干部大学老年身体机能康复课程老师

广州老年大学老年体适能课程老师

广州市老干部大学老年健身课程老师

广州市老年开发大学身体功能康复课程

广州多所康养机构身体功能康复课程

美国运动委员会教练ACE认证

美国体能协会教练NSCA认证

腰间盘突出康复训练师

感知觉统合训练师

运动损伤康复专家

老年功能康复训练师

国际营养师

全网30万➕粉丝博主

从事老年康复训练6年多，期间共帮助线下和线上万➕学员改善身体健康问题。擅长腰间盘突出、髋关节、膝关节、拇指外翻等慢性疼痛问题的康复，同时开发老年人如何正确走路课程，帮助老年人缓解膝盖、髋、腰不适。

从2021年至今在广州多所老年大学教老年身体机能康复课程，得到各大老年大学同学们认可和喜欢。

## 刘海鹏

![img](https://cdn.keihong.tech/img/20250421202925438.png)

心肺康复运动治疗师

美国运动医学会认证临床运动生理师(ACSM-CEP)

中国医科院肿瘤医院(国家癌症中心)综合科 运动康复师

北京航天总医院体重管理门诊运动指导师

从事体医融合工作近十年，先后在阜外医院心康中心、北京第一中西医结合医院学习心脏康复，负责过北京航天总医院减肥门诊、安贞医院健管中心、中日友好医院肾脏移植患者医务社工介入项目等科室和项目的运动康复工作。

擅长代谢疾病及心脏术后人群的运动评估和康复训练指导、阿尔兹海默病早期、肿瘤治疗及术后等疾病的运动康复。`
}
